<template>
  <div :class="{'d-none': load}">
    <div class="mt-5 mb-5">
      <h1 :class="{'text-white': $darkMode == 'true'}"><b>PIX</b></h1>
      <h4 :class="{'text-white': $darkMode == 'true', 'text-secondary': $darkMode == 'false'}">Pague o valor de R$ 150,00 para renovar por + 30 dias</h4>
      <hr style="max-width: 30%;" />
    </div>

    <div class="text-center pb-5" v-if="view =='id'">
      <h5 v-if="erro" class="text-danger mb-4"><small>Preencha um número válido</small></h5>
      <h5 :class="{'text-white': $darkMode == 'true'}">Informe o CPF/CNPJ</h5>
      <div class="d-flex justify-content-center">
        <input v-model="identificacao" class="form-control" :class="{'is-invalid':erro}" style="max-width: 230px;" type="text" @keyup="enterSalvar" placeholder="CPF/CNPJ"  />        
      </div>
      <h5 class="mt-2" :class="{'text-white': $darkMode == 'true'}">da conta utilizada para pagamento do PIX</h5>
      <button type="button" class="btn btn-lg btn-warning mt-2" @click="criarQrCode()">
        Criar QRCode
      </button>
    </div>

    <div class="text-center pb-5" v-if="view =='qrcode'">      
      <h2 class="mb-1 text-success"><b>Chave PIX</b></h2>
      <h3 class="mb-0" :class="{'text-white': $darkMode == 'true'}" @click="copiar">{{ chave }}</h3>
      <h5 style="cursor: pointer" class="mb-0" :class="{'text-white': $darkMode == 'true'}" @click="copiar"><small>clique aqui para copiar</small></h5>
      <div class="d-flex justify-content-center mt-2 mb-2">
          <img style="max-height: 300px;" :src="chaveQrCode"  alt="QR Code" />
      </div>
      <p :class="{'text-white': $darkMode == 'true'}"><small>{{ chaveInfo }}</small></p>
      <h5 class="mt-2" :class="{'text-white': $darkMode == 'true', 'text-secondary': $darkMode == 'false'}">Efetue o pagamento e aguarde alguns minutos para seu plano ser confirmado</h5>
    </div>
    
  </div>
</template>

<script>
import { api } from "@/services/api.js";
//import util from "../includes/util.js";

export default {
  name: "Pay",
  components: {},
  props: {
    
  },
  data: function () {
    return {
      identificacao:"",
      chave: "",
      chaveInfo: "",
      chaveQrCode: "",
      view:"id",
      erro:false,
      load: true
    };
  },
  methods: {
      async enterSalvar(event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          this.criarQrCode();
        }
      },
      async criarQrCode()
      {

        try {

          this.erro = false;

          let result = await api.put("/usuario/pay", { identificacao: this.identificacao });

          if(result.data && result.data.erro == false)
          {

            this.chave = result.data.item.key;
            this.chaveInfo = result.data.item.info;
            this.chaveQrCode = result.data.item.qrcode;

            this.view = "qrcode";

          }else{

            if(this.load == false)
            {
              this.erro = true;
            }

          }

          this.load = false;
          
        } catch (err) {
          this.erro = true;
        }

      },   
      async copiar()
      {

        try {
          await navigator.clipboard.writeText(this.chave);
        } catch (err) {
          console.error('Failed to copy: ', err);
        }

      } 
  },
  async mounted() {
    
    this.criarQrCode();

  },
  computed: {
    
  },
};
</script>

<style>
</style>
